webpackJsonp([1],{

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'axisbottom',
  props: ['scale', 'width', 'height', 'margin'],
  computed: {
    axis: function axis() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["axisBottom"])(this.scale).tickSize(this.height - this.margin.top - this.margin.bottom);
    }
  },
  render: function render(createElement) {
    if (this.$el) this.draw();
    return createElement('g', '');
  },
  methods: {
    draw: function draw() {
      var s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["select"])(this.$el).attr("transform", "translate(0," + this.margin.top + ")").call(this.axis);
      s.select('.domain').remove();
      s.selectAll('text').attr('dy', '1em');
    }
  },
  mounted: function mounted() {
    this.$forceUpdate();
  }
});

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);


var formatNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["format"])(",.2r");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'axisright',
  props: ['scale', 'width', 'height', 'margin', 'unit'],
  computed: {
    axis: function axis() {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["axisRight"])(this.scale).tickSize(this.width - this.margin.left - this.margin.right).tickFormat(function (d, i) {
        return d == 0 ? '0 ' + _this.unit : formatNumber(d);
      });
    }
  },
  render: function render(createElement) {
    if (this.$el) this.draw();
    return createElement('g', '');
  },
  methods: {
    draw: function draw() {
      var s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["select"])(this.$el).call(this.axis);
      s.select('.domain').remove();
      s.selectAll('text').attr('dx', '1em');
    }
  },
  mounted: function mounted() {
    this.$forceUpdate();
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(785),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02bc8f7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(786),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-143d925f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(788),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-308a5f98",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(795),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(791),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-555a642c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Vis__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Vis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Vis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Test__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Test__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_About__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/vis/:addr/:view',
    name: 'Vis',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Vis___default.a
  }, {
    path: '/',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_4__components_About___default.a
  }, {
    path: '/test',
    name: 'test',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Test___default.a
  }]
}));

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(793),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Graph__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Graph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Graph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  components: { Graph: __WEBPACK_IMPORTED_MODULE_0__components_Graph___default.a, Dashboard: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard___default.a }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Linechartsmall__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Linechartsmall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Linechartsmall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gauge__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Gauge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Panel__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_Rx__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var parseDate = function parseDate(date) {
  return new Date(date * 1000);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: { Gauge: __WEBPACK_IMPORTED_MODULE_2__Gauge___default.a, Panel: __WEBPACK_IMPORTED_MODULE_3__Panel___default.a, List: __WEBPACK_IMPORTED_MODULE_4__List___default.a, Linechartsmall: __WEBPACK_IMPORTED_MODULE_1__Linechartsmall___default.a },
  props: ['polling', 'pollingTime', 'addr'],
  data: function data() {
    return {
      url: 'https://api.nanopool.org/v1/zec',
      csvUrl: 'https://julianoliver.com/harvest/nodes/node1.csv',
      stats: null,
      priceUrl: 'https://min-api.cryptocompare.com/data/histominute?fsym=ZEC&tsym=USD&limit=300',
      priceHistory: null
    };
  },
  subscriptions: function subscriptions() {
    var _this = this;

    return {
      timepoll: __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx___default.a.Observable.timer(0, this.pollingTime).takeWhile(function (v) {
        return _this.polling ? true : v === 0;
      }).map(function (a) {
        return +new Date();
      }).do(function (a) {
        _this.getStats();
      }) // super hacky

      , lastblocknumber: this.$reactivelyFetchData(function () {
        return _this.url + '/network/lastblocknumber/?' + _this.timepoll;
      }),
      lastblocks: this.$reactivelyFetchData(function () {
        return _this.url + '/blocks/' + _this.lastblocknumber + '/100';
      }),
      history: this.$reactivelyFetchData(function () {
        return _this.url + '/history/' + _this.addr + '?' + _this.timepoll;
      }).map(function (data) {
        data.sort(function (a, b) {
          return a.date - b.date;
        });
        return data.map(function (d) {
          return {
            date: parseDate(d.date),
            value: d.hashrate
          };
        });
      }),

      user: this.$reactivelyFetchData(function () {
        return _this.url + '/user/' + _this.addr + '?' + _this.timepoll;
      }),
      payments: this.$reactivelyFetchData(function () {
        return _this.url + '/payments/' + _this.addr + '?' + _this.timepoll;
      }),
      avgblocktime: this.$reactivelyFetchData(function () {
        return _this.url + '/network/avgblocktime?' + _this.timepoll;
      }),
      prices: this.$reactivelyFetchData(function () {
        return _this.url + '/prices?' + _this.timepoll;
      }),
      totalpayout: this.$watchAsObservable(function () {
        return _this.payments;
      }).pluck('newValue').map(function (payouts) {
        return payouts.reduce(function (a, c) {
          return a + c.amount;
        }, 0);
      }),
      totalpayoutEur: this.$watchAsObservable(function () {
        return _this.totalpayout;
      }).pluck('newValue').mergeMap(function (val) {
        return _this.$watchAsObservable(function () {
          return _this.prices;
        }).pluck('newValue').map(function (d) {
          return (val * d.price_eur).toFixed(2);
        });
      })
      // .do(d => { console.log(d)}),
    };
  },

  methods: {
    getStats: function getStats() {
      var _this2 = this;

      var header = ['timestamp', 'windspeed', 'outsidetemp', 'gputemp', 'load'];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["text"])(this.csvUrl, function (text) {
        var parsed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["csvParseRows"])(text)[0];
        if (parsed.length) {
          var data = {};
          header.forEach(function (name, i) {
            data[name] = parsed[i];
          });
          data.date = new Date(data.timestamp * 1000);
          _this2.stats = data;
          // console.log(data)
          // this.history.push(data)
        }
      });
    },
    getPriceHistory: function getPriceHistory() {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["json"])(this.priceUrl, function (data) {
        if (data && data.Data) {
          _this3.priceHistory = data.Data.map(function (d) {
            return {
              date: new Date(d.time * 1000),
              value: d.close
            };
          });
        }
      });
    }
  },
  created: function created() {
    this.getPriceHistory();
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tween__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tween___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tween__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gauge',
  props: ['value', 'width', 'height', 'title', 'unit'],
  data: function data() {
    return {
      margin: 5,
      border: 25,
      max: 1,
      animatedNumber: 0
    };
  },
  watch: {
    value: function value(newValue, oldValue) {
      newValue = newValue * 1;
      oldValue = oldValue * 1;
      console.log(newValue, oldValue);
      if (newValue > this.max) this.max = newValue;

      var vm = this;
      function animate() {
        if (__WEBPACK_IMPORTED_MODULE_1_tween___default.a.update()) {
          requestAnimationFrame(animate);
        }
      }
      new __WEBPACK_IMPORTED_MODULE_1_tween___default.a.Tween({ tweeningNumber: oldValue }).easing(__WEBPACK_IMPORTED_MODULE_1_tween___default.a.Easing.Quadratic.Out).to({ tweeningNumber: newValue }, 2000).onUpdate(function () {
        vm.animatedNumber = this.tweeningNumber.toFixed(2);
      }).start();
      animate();
    }
  },
  computed: {
    rounded: function rounded() {
      return Math.round(this.animatedNumber * 10000) / 10000;
    },
    transform: function transform() {
      return 'translate(' + this.width / 2 + ', ' + (this.height / 2 + this.margin) + ')';
    },
    percent: function percent() {
      return this.animatedNumber / this.max;
    },
    arc: function arc() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["arc"])()
      // .cornerRadius(8)
      .innerRadius(this.width / 2 - this.margin - this.border).outerRadius(this.width / 2 - this.margin).startAngle(-Math.PI + 0.5).endAngle(this.percent * (2 * Math.PI - 1) - Math.PI + 0.5)();
    },
    backgroundArc: function backgroundArc() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["arc"])()
      // .cornerRadius(8)
      .innerRadius(this.width / 2 - this.margin - this.border).outerRadius(this.width / 2 - this.margin).startAngle(-Math.PI + 0.5).endAngle(Math.PI * 2 - (Math.PI + 0.5))();
    }
  },
  created: function created() {
    this.max = this.value * 1.1;
    this.animatedNumber = this.value * 1;
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Linechart__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Linechart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Linechart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Rx__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Rx__);
//
//
//
//
//
//
//
//
//
//
//
//
//





var parseDate = function parseDate(date) {
  return new Date(date * 1000);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: { Linechart: __WEBPACK_IMPORTED_MODULE_0__Linechart___default.a },
  props: ['polling', 'pollingTime', 'addr'],
  data: function data() {
    return {
      url: 'https://api.nanopool.org/v1/zec'
    };
  },
  subscriptions: function subscriptions() {
    var _this = this;

    return {
      timepoll: __WEBPACK_IMPORTED_MODULE_1_rxjs_Rx___default.a.Observable.timer(0, this.pollingTime).takeWhile(function (v) {
        return _this.polling ? true : v === 0;
      }).map(function (a) {
        return +new Date();
      }),

      history: this.$reactivelyFetchData(function () {
        return _this.url + '/history/' + _this.addr + '?' + _this.timepoll;
      }).map(function (data) {
        data.sort(function (a, b) {
          return a.date - b.date;
        });
        return data.map(function (d) {
          return {
            date: parseDate(d.date),
            value: d.hashrate
          };
        });
      })
    };
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Axisright_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Axisbottom_js__ = __webpack_require__(150);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'linechart',
  props: ['data', 'width', 'height', 'margin', 'title'],
  components: { Axisright: __WEBPACK_IMPORTED_MODULE_1__Axisright_js__["a" /* default */], Axisbottom: __WEBPACK_IMPORTED_MODULE_2__Axisbottom_js__["a" /* default */] },
  computed: {
    extentX: function extentX() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"])(this.data, function (d) {
        return d.date;
      });
    },
    scaleX: function scaleX() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["scaleTime"])().range([0, this.width - this.margin.left - this.margin.right]).domain(this.extentX);
    },
    extentY: function extentY() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"])(this.data, function (d) {
        return d.value;
      });
    },
    scaleY: function scaleY() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["scaleLinear"])().range([0, this.height - this.margin.top - this.margin.bottom]).domain([this.extentY[1], 0]);
    },
    linePath: function linePath() {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["line"])().x(function (d) {
        return _this.scaleX(d.date);
      }).y(function (d) {
        return _this.scaleY(d.value);
      })(this.data);
    },
    transform: function transform() {
      return 'translate(' + this.margin.left + ', ' + this.margin.top + ')';
    }
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Axisright_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Axisbottom_js__ = __webpack_require__(150);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'linechartsmall',
  props: ['data', 'width', 'height', 'margin', 'title', 'unit'],
  components: { Axisright: __WEBPACK_IMPORTED_MODULE_1__Axisright_js__["a" /* default */], Axisbottom: __WEBPACK_IMPORTED_MODULE_2__Axisbottom_js__["a" /* default */] },
  computed: {
    extentX: function extentX() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"])(this.data, function (d) {
        return d.date;
      });
    },
    scaleX: function scaleX() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["scaleTime"])().range([0, this.width - this.margin.left - this.margin.right]).domain(this.extentX);
    },
    extentY: function extentY() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"])(this.data, function (d) {
        return d.value;
      });
    },
    scaleY: function scaleY() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["scaleLinear"])().range([0, this.height - this.margin.top - this.margin.bottom]).domain([this.extentY[1], 0]);
    },
    linePath: function linePath() {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["line"])().x(function (d) {
        return _this.scaleX(d.date);
      }).y(function (d) {
        return _this.scaleY(d.value);
      })(this.data);
    },
    transform: function transform() {
      return 'translate(' + this.margin.left + ', ' + this.margin.top + ')';
    }
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'list',
  props: ['title', 'data'],
  computed: {
    block: function block() {
      // this.data.sort((a,b)=> b.number - b.number)
      // console.log(this.data)
      return this.data[this.data.length - 1];
    }
  },
  methods: {
    parseDate: function parseDate(date) {
      return new Date(date * 1000);
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'panel',
  props: ['value', 'width', 'height', 'title', 'unit'],
  computed: {}
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Linechart__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Linechart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Linechart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gauge__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Gauge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Panel__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_d3__);

//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'test',
  components: { Linechart: __WEBPACK_IMPORTED_MODULE_1__Linechart___default.a, Gauge: __WEBPACK_IMPORTED_MODULE_2__Gauge___default.a, Panel: __WEBPACK_IMPORTED_MODULE_3__Panel___default.a },
  data: function data() {
    return {
      url: 'https://julianoliver.com/harvest/nodes/node1.csv',
      history: [],
      stats: null
    };
  },
  methods: {
    updateStats: function updateStats(url) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var header = ['timestamp', 'windspeed', 'outsidetemp', 'load', 'gputemp'];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3__["text"])(url, function (text) {
          var parsed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3__["csvParseRows"])(text)[0];
          if (parsed.length) {
            var data = {};
            header.forEach(function (name, i) {
              data[name] = parsed[i];
            });
            data.date = new Date(data.timestamp * 1000);
            // this.stats = data
            // console.log(data)
            // this.history.push(data)
            resolve(data);
          }
        });
      });
    }
  },
  mounted: function mounted() {
    this.updateStats(this.url).then(function (d) {
      console.log(d);
    });
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Graph__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Graph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Graph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dashboard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vis',
  components: { Graph: __WEBPACK_IMPORTED_MODULE_0__components_Graph___default.a, Dashboard: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard___default.a }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_rx__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_rx__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_rx___default.a, __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

var fetchJson = function fetchJson(url) {
  return fetch(url);
};

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$reactivelyFetchData = function (getter) {
  return this.$watchAsObservable(getter).pluck('newValue').switchMap(function (url) {
    return __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx___default.a.Observable.fromPromise(fetch(url).then(function (r) {
      return r.json();
    })).catch(function (e) {
      console.log("api fetch error", e);
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx___default.a.Observable.of({ status: false });
    });
  }).filter(function (r) {
    return r.status;
  }).map(function (r) {
    return r.data;
  });
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(790),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44540a1a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(789),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(794),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-860ee1b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(787),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2869091c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(792),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59089986",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 785:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user && _vm.user.workers.length > 0) ? _c('gauge', {
    attrs: {
      "title": "Hashrate worker 1",
      "width": "235",
      "height": "246",
      "unit": "sol/s",
      "value": _vm.user.workers[0].hashrate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.workers.length > 1) ? _c('gauge', {
    attrs: {
      "title": "Hashrate worker 2",
      "width": "235",
      "height": "246",
      "unit": "sol/s",
      "value": _vm.user.workers[1].hashrate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('panel', {
    attrs: {
      "title": "address",
      "unit": "",
      "value": _vm.user.account
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('panel', {
    attrs: {
      "title": "Unconfirmed Pool Balance",
      "unit": "zec",
      "value": _vm.user.unconfirmed_balance
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('panel', {
    attrs: {
      "title": "Pool Balance",
      "unit": "zec",
      "value": _vm.user.balance
    }
  }, [_c('div', {
    staticClass: "line",
    style: ({
      width: (_vm.user.balance / 0.01) * 100 + '%'
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.stats) ? _c('panel', {
    attrs: {
      "title": "outside temperature",
      "unit": "°C",
      "value": _vm.stats.outsidetemp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats) ? _c('panel', {
    attrs: {
      "title": "GPU load",
      "unit": "W",
      "value": _vm.stats.load
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats) ? _c('panel', {
    attrs: {
      "title": "GPU temp",
      "unit": "°C",
      "value": _vm.stats.gputemp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.payments) ? _c('panel', {
    attrs: {
      "title": "payouts",
      "unit": "",
      "value": _vm.payments.length
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lastblocknumber) ? _c('panel', {
    attrs: {
      "title": "last block number",
      "unit": "",
      "value": _vm.lastblocknumber
    }
  }) : _vm._e(), _vm._v(" "), (_vm.avgblocktime) ? _c('panel', {
    attrs: {
      "title": "avg blocktime",
      "unit": "seconds",
      "value": _vm.avgblocktime.toFixed(2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.totalpayout) ? _c('panel', {
    attrs: {
      "title": "total mined",
      "unit": "zec",
      "value": _vm.totalpayout.toFixed(4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.totalpayoutEur) ? _c('panel', {
    attrs: {
      "title": "total mined",
      "unit": "€",
      "value": _vm.totalpayoutEur
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lastblocks) ? _c('list', {
    attrs: {
      "title": "Last block",
      "data": _vm.lastblocks
    }
  }) : _vm._e(), _vm._v(" "), (_vm.priceHistory) ? _c('linechartsmall', {
    attrs: {
      "title": "ZEC price history",
      "width": "550",
      "height": "173",
      "unit": "$",
      "data": _vm.priceHistory,
      "margin": {
        top: 0,
        right: 45,
        bottom: 20,
        left: 15
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 786:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gauge"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    staticClass: "backgroundArc",
    attrs: {
      "d": _vm.backgroundArc
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "arc",
    attrs: {
      "d": _vm.arc
    }
  }), _vm._v(" "), _c('text', [_vm._v(_vm._s(_vm.rounded) + " " + _vm._s(_vm.unit))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 787:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gauge', {
    attrs: {
      "title": "windspeed",
      "height": "200",
      "width": "200",
      "unit": "m/s",
      "value": 8
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 788:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.history) ? _c('linechart', {
    attrs: {
      "title": "Hashrate History",
      "width": "1750",
      "height": "820",
      "data": _vm.history,
      "margin": {
        top: 20,
        right: 80,
        bottom: 30,
        left: 10
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 789:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chartsmall"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('axisright', {
    staticClass: "axis",
    attrs: {
      "scale": _vm.scaleY,
      "width": _vm.width,
      "height": _vm.height,
      "margin": _vm.margin,
      "unit": _vm.unit
    }
  }), _vm._v(" "), _c('axisbottom', {
    staticClass: "axis axisx",
    attrs: {
      "scale": _vm.scaleX,
      "width": _vm.width,
      "height": _vm.height,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.linePath
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 790:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('dashboard', {
    staticClass: "scaledDashboard",
    attrs: {
      "pollingTime": "30000",
      "polling": "true",
      "addr": "t1YR6ihrgmWWGp4kDjyeXRpbUgEUzmFDSVC"
    }
  }), _vm._v(" "), _c('graph', {
    staticClass: "scaledGraph",
    attrs: {
      "pollingTime": "30000",
      "polling": "true",
      "addr": "t1YR6ihrgmWWGp4kDjyeXRpbUgEUzmFDSVC"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('h1', [_vm._v("HARVEST PROJECTION ENDPOINT")]), _vm._v(" "), _c('p', [_vm._v("\n      This is the endpoint of the realtime projection for Julian Olivers "), _c('a', {
    attrs: {
      "href": "https://julianoliver.com/output/harvest",
      "target": "_blank"
    }
  }, [_vm._v("HARVEST")]), _vm._v(" installation.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      There are 2 views: "), _c('a', {
    attrs: {
      "href": "#/vis/t1YR6ihrgmWWGp4kDjyeXRpbUgEUzmFDSVC/graph"
    }
  }, [_vm._v("hashrate history")]), _vm._v(" & "), _c('a', {
    attrs: {
      "href": "#/vis/t1YR6ihrgmWWGp4kDjyeXRpbUgEUzmFDSVC/dashboard"
    }
  }, [_vm._v("dashboard")]), _vm._v(" both are optimized for full hd. To display your own miner just change the ZEC address in the url to yours. You can find the source code on "), _c('a', {
    attrs: {
      "href": "https://github.com/cpietsch/harvest",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")]), _vm._v(".\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      APIs used: "), _c('a', {
    attrs: {
      "href": "https://zec.nanopool.org/api",
      "target": "_blank"
    }
  }, [_vm._v("Nanopool")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://min-api.cryptocompare.com",
      "target": "_blank"
    }
  }, [_vm._v("Cryptocompare")])]), _vm._v(" "), _c('p', [_vm._v("\n      Created by "), _c('a', {
    attrs: {
      "href": "https://chrispie.com",
      "target": "_blank"
    }
  }, [_vm._v("Christopher Pietsch")]), _vm._v(" 2017-2018\n    ")])])
}]}

/***/ }),

/***/ 791:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.value) + " " + _vm._s(_vm.unit))])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 792:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.params.view === 'dashboard') ? _c('dashboard', {
    attrs: {
      "pollingTime": "30000",
      "polling": "true",
      "addr": _vm.$route.params.addr
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.view === 'graph') ? _c('graph', {
    attrs: {
      "pollingTime": "30000",
      "polling": "true",
      "addr": _vm.$route.params.addr
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 793:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 794:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("date")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.parseDate(_vm.block.date)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("number")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.block.number))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("hash")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.block.hash))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("difficulty")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.block.difficulty))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("miner")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.block.miner))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', [_c('axisright', {
    staticClass: "axis",
    attrs: {
      "scale": _vm.scaleY,
      "width": _vm.width,
      "height": _vm.height,
      "margin": _vm.margin,
      "unit": "sol/s"
    }
  }), _vm._v(" "), _c('axisbottom', {
    staticClass: "axis axisx",
    attrs: {
      "scale": _vm.scaleX,
      "width": _vm.width,
      "height": _vm.height,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.linePath
    }
  })], 1)])])
},staticRenderFns: []}

/***/ })

},[250]);


// WEBPACK FOOTER //
// static/js/app.053b17d55f4e60b80a76.js